/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%}[_nghost-%COMP%]   .happ-button-list[_ngcontent-%COMP%]{background:#fff;margin:5px;font-size:18px;padding:5px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:inline-block}[_nghost-%COMP%]   .happ-list[_ngcontent-%COMP%]{flex-wrap:wrap}[_nghost-%COMP%]   .happ-small-button[_ngcontent-%COMP%]{line-height:25px!important}"];
export { styles as styles };
